import Link from '@components/primitives/Link'
import { classMerge } from '@components/utilities/classMerge'
import { type FooterColorConfig } from './footerColors'

export default function CookiesLink({
  colorConfig,
  onClick,
}: {
  colorConfig: FooterColorConfig
  onClick?: () => void
}) {
  return (
    <Link
      className={classMerge(
        'mr-2 inline text-[length:0.875rem] font-medium leading-[140%] md:mr-8 md:text-[length:0.875rem] md:leading-[140%]',
        colorConfig.textColor,
      )}
      href={'#cookies'}
      onClick={onClick}
    >
      Cookies
    </Link>
  )
}
